<template>
  <v-container>
    <page-title title="About" />
  
  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
export default {
  components: { PageTitle },
};
</script>
